import { createSlice } from '@reduxjs/toolkit'

export const addressSlice = createSlice({
  name: 'address',
  initialState: {
    street: 'Sheikh Zayed',
    city: 'Al Abar',
    state: 'Sharjah',
    zip: '00000',
    country: 'United Arab Emirates'
  },
  reducers: {
    setAddressField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    initializeAddress(state, action) {
      state.street = 'Sheikh Zayed'
      state.city = 'Al Abar'
      state.state = 'Sharjah'
      state.zip = '00000'
      state.country = 'United Arab Emirates'
    }
  }
})

export const {
  setAddressField,
  initializeAddress
} = addressSlice.actions
export default addressSlice.reducer